import { Header, Icon } from '@iqueue/ui-kit'
import cn from 'classnames'
import useTranslate from '../../../hooks/useTranslate'
import { i18nScope } from '../translations'
import HourlyProductionChart from './HourlyProductionChart'
import WellOperationFactor from '../WellOperationFactor'
import { UNIT_PRESSURE, UNIT_TEMPERATURE } from '../Measurement'
import { t } from '../../../hooks/useTranslate'

export default function WellCard(props) {
  const {
    /*
     pressurePlumeHourlyChart={ Object.values(pathOr({}, ['PRESSURE_PLUME', 'hourlyChart'], data)) }
     pressurePlumeSummary={ path(['PRESSURE_PLUME', 'summary'], data) }
     pressureWellHourlyChart={ Object.values(pathOr({}, ['PRESSURE_WELL', 'hourlyChart'], data)) }
     pressureWellSummary={ path(['PRESSURE_WELL', 'summary'], data) }
     temperatureHourlyChart={ Object.values(pathOr({}, ['TEMPERATURE', 'hourlyChart'], data)) }
     temperatureSummary={ path(['TEMPERATURE', 'summary'], data) }
     */

    pressurePlumeHourlyChart = [],
    pressurePlumeSummary: {
      hourlyValue: hourlyValuePP = 0,
      pastHourValue: pastHourValuePP = 0,
    } = {},

    pressureWellHourlyChart = [],
    // pressureWellSummary: {
    //   hourlyValue: hourlyValuePW = 0,
    //   pastHourValue: pastHourValuePW = 0,
    // } = {},

    temperatureHourlyChart = [],
    temperatureSummary: {
      hourlyValue: hourlyValueT = 0,
      pastHourValue: pastHourValueT = 0,
    } = {},

    summary: {
      hourlyValue = 0,
      pastHourValue = 0,
      dailyValue = 0,
      pastDayValue = 0,
      monthlyValue = 0,
      pastMonthValue = 0,
      yearlyValue = 0,
      pastYearValue = 0,
    } = {},
    operatingFactor,
    hourlyChart = [],
    type,
    name = 'Well',
    className,
    onClick,
  } = props

  return <div
    className={ cn('gas-and-oil-card interactive', className) }
    onClick={ onClick }
  >
    <Header
      title={ <>
        <b><Icon filled>local_fire_department</Icon></b>
        <span>{ name }</span>
      </> }
      extra={ <WellOperationFactor factor={ operatingFactor }/> }
      subtitle={ t(`type.node.${ type }`) }
    />

    <div className={ 'content' }>
      <HourlyProductionChart
        subtitle={ <span>
  { t('type.sensor.PRESSURE') } {t('type.pressure.in')}{ ' ' }
          <span
            style={ { color: 'var(--iq-accent)' } }>{ t('type.node.HOLE') }</span> { t('type.pressure.and') }{ ' ' }
          <span style={ { color: 'var(--iq-accent-secondary)' } }>{ t('type.pressure.plume') }</span>
</span>
        }
        unit={ UNIT_PRESSURE }
        hourlyData={ pressureWellHourlyChart }
        extraData={ pressurePlumeHourlyChart }
        currentHourValue={ hourlyValuePP }
        pastHourValue={ pastHourValuePP }
      />

      <HourlyProductionChart
        subtitle={ 'Температура' }
        unit={ UNIT_TEMPERATURE }
        hourlyData={ temperatureHourlyChart }
        currentHourValue={ hourlyValueT }
        pastHourValue={ pastHourValueT }
      />

      {/*<div>*/ }
      {/*  <div>Текущее давление на входе</div>*/ }
      {/*  <div>Текущая температура</div>*/ }
      {/*  <div>Текущее давление на выходе</div>*/ }
      {/*  <p/>*/ }
      {/*</div>*/ }

      {/* TODO Давление и температура */ }

      {/*<ProductionDiffLine*/ }
      {/*  title={ t('hourlyProduction') }*/ }
      {/*  current={ hourlyValue }*/ }
      {/*  past={ pastHourValue }*/ }
      {/*/>*/ }

      {/*<ProductionDiffLine*/ }
      {/*  title={ t('dailyProduction') }*/ }
      {/*  current={ dailyValue }*/ }
      {/*  past={ pastDayValue }*/ }
      {/*/>*/ }

      {/*<ProductionDiffLine*/ }
      {/*  title={ t('monthlyProduction') }*/ }
      {/*  current={ monthlyValue }*/ }
      {/*  past={ pastMonthValue }*/ }
      {/*/>*/ }
    </div>
  </div>
}
